<template>
    <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue'
import { WHITE_COLOUR, GREEN_COLOUR, YELLOW_COLOUR, RED_COLOUR } from '@/constants/colours.js'
import Highcharts from 'highcharts'
import hcMore from 'highcharts/highcharts-more'
import SolidGauge from 'highcharts/modules/solid-gauge'

hcMore(Highcharts)
SolidGauge(Highcharts)

export default {
    components: {
        'highcharts': Chart
    },
    data () {
        return {
            WHITE_COLOUR
        }
    },
    props: {
        labels: {
            type: Array,
            required: true
        },
        result: {
            type: Number,
            required: true
        },
        opposedColours: {
            type: Boolean,
            required: false,
            default: false
        },
        customColour: {
            type: String,
            required: false
        }
    },
    computed: {
        chartOptions () {
            var _this = this
            return {
                chart: {
                    type: 'solidgauge',
                    backgroundColor: 'transparent',
                    height: 150
                },
                title: null,
                pane: {
                    center: ['50%', '88%'],
                    size: '170%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: WHITE_COLOUR,
                        innerRadius: '75%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },
                tooltip: {
                    enabled: false
                },
                yAxis: {
                    stops: !_this.customColour ? _this.opposedColours ? [
                        [0.1, GREEN_COLOUR],
                        [0.5, YELLOW_COLOUR],
                        [0.9, RED_COLOUR]
                    ] : [
                        [0.1, RED_COLOUR],
                        [0.5, YELLOW_COLOUR],
                        [0.9, GREEN_COLOUR]
                    ] : null,
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickWidth: 0,
                    labels: {
                        y: 16,
                        style: {
                            color: WHITE_COLOUR,
                            fontFamily: 'Space Grotesk'
                        },
                        formatter: function () {
                            return this.value === 0 ? 'Min' : 'Max'
                        }
                    },
                    tickInterval: 100,
                    min: 0,
                    max: 100
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    solidgauge: {
                        innerRadius: '75%',
                        radius: '100%'
                    }
                },
                series: [{
                    data: [{y: _this.result, color: _this.customColour ? _this.customColour : null}],
                    color: this.customColour ? this.customColour : null,
                    dataLabels: {
                        y: -40,
                        borderWidth: 0,
                        useHTML: true,
                        formatter: function () {
                            return `${this.y}%`
                        },
                        style: {
                            fontSize: '233%',
                            color: WHITE_COLOUR,
                            fontFamily: 'Space Grotesk'
                        }
                    }
                }]
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/charts/GaugeChart.vue